export const orange = {
  base1: '#e85b00',
  base2: '#de5700',
  base3: '#f76100'
};
export const neutral = {
  gray1: '#f8f8f8',
  gray2: '#e1e4e8',
  gray3: '#cfd4da',
  gray4: '#939da8',
  gray5: '#6d7782',
  gray6: '#555555',
  gray7: '#59636e',
  gray8: '#414c58',
  gray9: '#2d363e',
  white: '#fff',
  black: '#000',
  offWhite: '#f8f8f8'
};
export const blue = {
  base1: '#eeeff8',
  base2: '#dee4f5',
  base3: '#c2cbe5',
  base4: '#4b6ed2',
  base5: '#234eae',
  base6: '#0f3485',
  base7: '#012169',
  base8: '#102b4e'
};
export const indigo = {
  base1: '#f3f4fa',
  base2: '#dee2ec'
};
export const green = {
  base1: '#e8f0e8',
  base2: '#d6e4d2',
  base3: '#b1ed8e',
  base4: '#4cae4c',
  base5: '#258e25',
  base6: '#407340'
};
export const yellow = {
  base1: '#fff8e8',
  base2: '#ffe8cf',
  base3: '#fdb714',
  base4: '#906501'
};
export const red = {
  base1: '#fcefee',
  base2: '#f8d8db',
  base3: '#ec4855',
  base4: '#b42420'
};
//# sourceMappingURL=colors.js.map